import { type ReactNode, useEffect, useState } from 'react';
import {
  MsalProvider,
  type IMsalContext,
} from '@azure/msal-react';
import {
  EventType,
  type EventMessage,
  type AuthenticationResult,
} from '@azure/msal-browser';
import { msalInstance } from './msalConfig';

interface AuthProviderProps {
  children: ReactNode;
}

export function AuthProvider({ children }: AuthProviderProps) {
  const [initialized, setInitialized] = useState(false);

  useEffect(() => {
    const init = async () => {
      await msalInstance.initialize();

      const accounts = msalInstance.getAllAccounts();
      if (accounts.length > 0) {
        msalInstance.setActiveAccount(accounts[0] ?? null);
      }

      msalInstance.addEventCallback((event: EventMessage) => {
        if (
          event.eventType === EventType.LOGIN_SUCCESS &&
          event.payload
        ) {
          const result = event.payload as AuthenticationResult;
          msalInstance.setActiveAccount(result.account);
        }
      });

      await msalInstance.handleRedirectPromise();
      setInitialized(true);
    };

    init().catch((err) => {
      console.error('[AuthProvider] initialization failed:', err);
      setInitialized(true);
    });
  }, []);

  if (!initialized) {
    return null;
  }

  return <MsalProvider instance={msalInstance}>{children}</MsalProvider>;
}

export type { IMsalContext };

